export const LENGTH_OVERALL = 'length_overall'
export const BREADTH = 'breadth'
export const LADEN_DRAUGHT = 'laden_draught'
export const BALLASTED_DRAUGHT = 'ballasted_draught'
export const DEPTH_MAIN_DECK_TO_KEEL = 'depth_main_deck_to_keel'
export const DEPTH_FORECASTLE_DECK_TO_KEEL = 'depth_forecastle_deck_to_keel'
export const DEPTH_POOP_DECK_TO_KEEL = 'depth_poop_deck_to_keel'
export const FORWARD_PARALLEL_BODY_LENGTH = 'forward_parallel_body_length'
export const AFTERWARD_PARALLEL_BODY_LENGTH = 'aftward_parallel_body_length'
export const NUMBER = 'number'
export const CAPACITY = 'capacity'
export const ECCENTRICITY = 'eccentricity'
